import style from '../scss/body.module.scss';
import Sidebar from '@/components/sidebar';
import Document from '@/components/document';

export default function Body() {
    return <div className={style.body}>
        <Sidebar />
        <Document />
    </div>;
}
